import { GlobalConstantsTableCols } from "globales-projekt-angular";

export class ConstantsTableColsKge extends GlobalConstantsTableCols {

  static readonly KGE: string = 'KGE';
  static readonly NUTZUNGSDAUER: string = 'NUTZUNGSDAUER';
  static readonly SELECTED: string = 'SELECTED';

  public static getColumns(): string[] {
    return [this.SELECTED, this.KGE, this.BEZEICHNUNG, this.NUTZUNGSDAUER];
  }

  public static getColumnsHeader(): string[] {
    return [this.SELECTED, this.KGE, this.NUTZUNGSDAUER];
  }  
}